import { ReactNode, useEffect } from "react";
import * as Sentry from "@sentry/react";
import { useLocation } from "react-router-dom";
import Loader from "components/shared/loader";
import { isChunkLoadError, reloadOnceForChunkError } from "./lazyWithRetry";

const RECOVERY_DELAY_MS = 500;
const recoveryAttempts = new Set<string>();

const SilentRecovery = ({ error, resetError, pathname }: { error: unknown; resetError: () => void; pathname: string }) => {
  useEffect(() => {
    if (isChunkLoadError(error)) {
      reloadOnceForChunkError();
      return;
    }
    if (recoveryAttempts.has(pathname)) return;
    recoveryAttempts.add(pathname);
    const timer = setTimeout(resetError, RECOVERY_DELAY_MS);
    return () => clearTimeout(timer);
  }, [error, resetError, pathname]);

  return <Loader />;
};

export default function RouteErrorBoundary({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  return (
    <Sentry.ErrorBoundary key={pathname} fallback={({ error, resetError }) => <SilentRecovery error={error} resetError={resetError} pathname={pathname} />}>
      {children}
    </Sentry.ErrorBoundary>
  );
}
